/**
 * NewCustomerForm.jsx
 * Created by Hassan Riaz on 1/16/20.
 */

import React from 'react';
import PropTypes from 'prop-types';

import Notification from '../../../sharedComponents/Notification';
import TextField from '../../../sharedComponents/TextField';
import PhoneNumberField from '../../../sharedComponents/TextField/PhoneNumberField';
import EmailField from '../../../sharedComponents/TextField/EmailField';
import Checkbox from '../../../sharedComponents/Checkbox';
import Button from '../../../sharedComponents/Button/Button';

export default class NewCustomerForm extends React.PureComponent {
    static propTypes = {
        createAndSelect: PropTypes.func,
        error: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.state = {
            firstName: '',
            lastName: '',
            cellPhone: '',
            email: '',
            hasNoEmail: false
        };
    }

    handleChange = (e) => {
        const field = e.target.name;
        const val = e.target.value;
        this.setState({
            [field]: val
        });
    }

    handleCheckboxChange = (e) => {
        const hasNoEmail = e.target.checked;
        this.setState({
            hasNoEmail,
            email:''
        });
    }

    create = (e) => {
        // TODO: validation
        e.preventDefault();
        this.props.createAndSelect(
            this.state.firstName,
            this.state.lastName,
            this.state.cellPhone,
            this.state.email,
            this.state.hasNoEmail
        );
    }


    render() {
        let error = null;
        if (this.props.error) {
            error = (
                <div className="mb-2">
                    <Notification type="error">
                        {this.props.error}
                    </Notification>
                </div>
            );
        }

        return (
            <form onSubmit={this.create}>
                {error}
                <div className="mb-2">
                    <TextField
                        id="first-name"
                        label="First Name"
                        name="firstName"
                        isRequired
                        value={this.state.firstName}
                        onChange={this.handleChange} />
                </div>
                <div className="mb-2">
                    <TextField
                        id="last-name"
                        label="Last Name"
                        name="lastName"
                        isRequired
                        value={this.state.lastName}
                        onChange={this.handleChange} />
                </div>
                <div className="mb-2">
                    <PhoneNumberField
                        id="cell-phone"
                        label="Mobile Phone"
                        name="cellPhone"
                        isRequired
                        value={this.state.cellPhone}
                        onChange={this.handleChange} />
                </div>
                <div className="mb-2">
                    <EmailField
                        id="email"
                        label="Email"
                        name="email"
                        value={this.state.email}
                        onChange={this.handleChange}
                        isDisabled={this.state.hasNoEmail} />
                </div>
                <div className="mb-2">
                    <Checkbox
                        id="hasNoEmail"
                        label="Customer does not have an email address."
                        name="hasNoEmail"
                        value="hasNoEmail"
                        isChecked={this.state.hasNoEmail}
                        onChange={this.handleCheckboxChange} />
                </div>
                <div>
                    <Button type="submit">
                        Create and Select
                    </Button>
                </div>
            </form>
        );
    }
}
